import React, { useState, useEffect, useRef } from "react";
import { Link,useParams } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import axios from "axios";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import apiConfig from '../apiConfig';


const ExchangeSummery = () => {

    const { id } = useParams();
    const isSingleUser = Boolean(id);

    
    
  const [loading, setLoading]           = useState(true);
  const [detailData, setDetailData]     = useState([]);
  const [matchSummary, setMatchSummary] = useState([]);
  const [matchSort, setMatchSort]       = useState({ key: 'lastSettledAt', direction: 'desc' });

  const [summary, setSummary] = useState({
    totalBets: 0, totalWin: 0, totalLoss: 0, netProfitLoss: 0, uniquePlayers: 0
  });

  const [pageCount, setPageCount]     = useState(1);
  const [activeRange, setActiveRange] = useState('today');
  const [startDate, setStartDate]     = useState('');
  const [endDate, setEndDate]         = useState('');
  const [matchName, setMatchName]     = useState('');
  const [betFaireType, setBetFaireType] = useState('');

  const [sortConfig, setSortConfig] = useState({ key: "createdAt", direction: "desc" });
  const currentPage = useRef(1);
  const limit = 50;

  // ── Tabs ──────────────────────────────────────────────────────────────────
  const [activeTab, setActiveTab] = useState('match'); // 'match' | 'detail'

  // ── Helpers ──────────────────────────────────────────────────────────────
  const toLocalDateString = (d) => {
    const year  = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day   = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const formatDate = (iso) => {
    const d = new Date(iso);
    return `${String(d.getDate()).padStart(2,'0')}.${String(d.getMonth()+1).padStart(2,'0')}.${d.getFullYear()} `
         + `${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
  };

  const getDateRange = (range) => {
    const now      = new Date();
    const todayStr = toLocalDateString(now);
    if (range === 'today')   return { start: todayStr, end: todayStr };
    if (range === 'weekly')  {
      const s = new Date(now); s.setDate(now.getDate() - 7);
      return { start: toLocalDateString(s), end: todayStr };
    }
    if (range === 'monthly') {
      const s = new Date(now.getFullYear(), now.getMonth(), 1);
      return { start: toLocalDateString(s), end: todayStr };
    }
    return { start: '', end: '' };
  };

  // ── Fetch ─────────────────────────────────────────────────────────────────
  const fetchData = async (
    start, end,
    pageOnly    = false,
    srchMatch   = matchName,
    srchType    = betFaireType
  ) => {
    setLoading(true);
    try {
      const res = await axios.get(`${apiConfig.baseURL}/api/agent/nineWicketSummery`, {
        params: {
          startDate:    start      || undefined,
          endDate:      end        || undefined,
          page:         currentPage.current,
          limit,
          skipSummary:  pageOnly ? 'true' : 'false',
          matchName:    srchMatch  || undefined,
          betFaireType: srchType   || undefined,
          betFaireType: srchType   || undefined,
          username:     isSingleUser ? id : undefined,  
        }
      });

      setDetailData(res.data.data || []);

      if (!pageOnly) {
        setSummary({
          totalBets:     res.data.totalBets     || 0,
          totalWin:      res.data.totalWin      || 0,
          totalLoss:     res.data.totalLoss     || 0,
          netProfitLoss: res.data.netProfitLoss || 0,
          uniquePlayers: res.data.uniquePlayers || 0,
        });
        setMatchSummary(res.data.matchSummary || []);
      }

      setPageCount(res.data.pageCount || 1);
    } catch (err) {
      console.error("exchangeSummery fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  // ── Initial load ──────────────────────────────────────────────────────────
  useEffect(() => {
    const { start, end } = getDateRange('today');
    setStartDate(start);
    setEndDate(end);
    fetchData(start, end);
  }, []);

  // ── Handlers ──────────────────────────────────────────────────────────────
  const handleRangeClick = (range) => {
    setActiveRange(range);
    if (range === 'custom') return;
    const { start, end } = getDateRange(range);
    setStartDate(start);
    setEndDate(end);
    currentPage.current = 1;
    fetchData(start, end, false, matchName, betFaireType);
  };

  const handleSearch = () => {
    currentPage.current = 1;
    fetchData(startDate, endDate, false, matchName, betFaireType);
  };

  const handleClear = () => {
    setMatchName('');
    setBetFaireType('');
    currentPage.current = 1;
    fetchData(startDate, endDate, false, '', '');
  };

  const handlePageClick = (e) => {
    currentPage.current = e.selected + 1;
    fetchData(startDate, endDate, true, matchName, betFaireType);
  };

  // ── Match-wise sort (client-side) ─────────────────────────────────────────
  const sortedMatches = [...matchSummary].sort((a, b) => {
    const dir = matchSort.direction === 'asc' ? 1 : -1;
    if (matchSort.key === 'matchName' || matchSort.key === 'betFaireType')
      return dir * String(a[matchSort.key]).localeCompare(String(b[matchSort.key]));
    if (matchSort.key === 'lastSettledAt')
      return dir * (new Date(a[matchSort.key]) - new Date(b[matchSort.key]));
    return dir * ((a[matchSort.key] || 0) - (b[matchSort.key] || 0));
  });

  const handleMatchSort = (key) => {
    setMatchSort(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'desc' ? 'asc' : 'desc'
    }));
  };

  const MatchSortIcon = ({ field }) => {
    if (matchSort.key !== field) return <span style={{ color: '#888' }}> ↕</span>;
    return <span> {matchSort.direction === 'asc' ? '↑' : '↓'}</span>;
  };

  // ── Detail table sort (client-side) ──────────────────────────────────────
  const sortDetail = (key) => {
    const dir = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    const sorted = [...detailData].sort((a, b) => {
      if (key === 'profitLoss' || key === 'amount')
        return dir === 'asc' ? a[key] - b[key] : b[key] - a[key];
      return dir === 'asc'
        ? new Date(a.createdAt) - new Date(b.createdAt)
        : new Date(b.createdAt) - new Date(a.createdAt);
    });
    setDetailData(sorted);
    setSortConfig({ key, direction: dir });
  };

  const SortIcon = ({ field }) => {
    if (sortConfig.key !== field) return <span style={{ color: '#888' }}> ↕</span>;
    return <span> {sortConfig.direction === 'asc' ? '↑' : '↓'}</span>;
  };

  // ── Styles ────────────────────────────────────────────────────────────────
  const MyPaginate = styled(ReactPaginate).attrs({ activeClassName: "active" })`
    margin: 0.5rem 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    list-style-type: none;
    padding: 0;
    gap: 4px;
    li a { border-radius: 6px; padding: 3px 9px; border: 1px solid #334155; cursor: pointer; color: #000; font-size: 12px; }
    li.active a { background: #f59e0b; border-color: #f59e0b; color: #000; font-weight: 700; }
    li.disabled a { color: #aaa; cursor: default; }
  `;

  const rangeButtons = ['today', 'weekly', 'monthly', 'custom'];

  const thStyle = {
    color: '#000',
    background: '#fff',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    fontWeight: '600',
    fontSize: '12px',
    padding: '6px 8px',
  };

  // ── Compact stat card config ────────────────────────────────────────────
  const statCards = [
    { label: 'Total Bets', value: summary.totalBets, color: '#000' },
    { label: 'Players',    value: summary.uniquePlayers, color: '#000' },
    { label: 'Players Won', value: `+৳${summary.totalWin?.toLocaleString()}`, color: '#16a34a' },
    { label: 'Players Lost', value: `৳${summary.totalLoss?.toLocaleString()}`, color: '#dc2626' },
    {
      label: 'Net P/L',
      value: `${summary.netProfitLoss >= 0 ? '+' : ''}৳${summary.netProfitLoss?.toLocaleString()}`,
      color: summary.netProfitLoss >= 0 ? '#16a34a' : '#dc2626',
    },
  ];

  // ── Compact input style (shared, small footprint on mobile) ─────────────
  const compactInputStyle = {
    background: '#fff', color: '#000', border: '1px solid #334155',
    fontSize: '12px', padding: '4px 6px', height: '30px',
  };

  // ─────────────────────────────────────────────────────────────────────────
  return (
    <>
      <Navbar /><Chatbox /><HeaderRight /><LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-12">

            {/* ── Header ── */}
            <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
              <Link to="/NineWicket" className="btn btn-outline-secondary btn-sm active">9Wicket</Link>
              {/* <Link to="/exchange-summery" className="btn btn-outline-secondary btn-sm ">Lucky</Link>
              <Link to="/casino-summery" className="btn btn-outline-secondary btn-sm">Casino</Link> */}
            </div>

            {/* ── Date Range Buttons ── */}
            <div className="mb-2 d-flex gap-2 flex-wrap">
              {rangeButtons.map(r => (
                <button key={r}
                  onClick={() => handleRangeClick(r)}
                  style={{
                    padding: '4px 10px', borderRadius: '20px',
                    cursor: 'pointer', fontSize: '12px', fontWeight: '600',
                    background: activeRange === r ? '#f59e0b' : '#fff', color: '#000',
                    border: '1px solid #e2e8f0',
                  }}>
                  {r.charAt(0).toUpperCase() + r.slice(1)}
                </button>
              ))}
            </div>

            {/* ── Custom Date (wraps on mobile instead of clipping) ── */}
            {activeRange === 'custom' && (
              <div className="mb-2 d-flex align-items-center" style={{ flexWrap: 'wrap', gap: '6px' }}>
                <input type="date" value={startDate}
                  onChange={e => setStartDate(e.target.value)}
                  style={{
                    ...compactInputStyle,
                    width: '132px', minWidth: '132px', maxWidth: '132px',
                    flexShrink: 0, flexGrow: 0,
                    borderRadius: '4px', boxSizing: 'border-box', display: 'block',
                  }} />
                <span style={{ color: '#000', fontSize: '12px', flexShrink: 0 }}>→</span>
                <input type="date" value={endDate}
                  onChange={e => setEndDate(e.target.value)}
                  style={{
                    ...compactInputStyle,
                    width: '132px', minWidth: '132px', maxWidth: '132px',
                    flexShrink: 0, flexGrow: 0,
                    borderRadius: '4px', boxSizing: 'border-box', display: 'block',
                  }} />
                <button
                  onClick={() => { currentPage.current = 1; fetchData(startDate, endDate, false, matchName, betFaireType); }}
                  className="btn btn-sm"
                  style={{ background: '#f59e0b', color: '#000', fontWeight: '700', fontSize: '12px', flexShrink: 0, height: '30px' }}>
                  Search
                </button>
              </div>
            )}

            {/* ── Search Bar ── */}
            <div className="row mb-2 g-2 align-items-end">
              <div className="col-6 col-md-4">
                <label style={{ color: '#000', fontSize: '11px', marginBottom: '2px', display: 'block' }}>Match Name</label>
                <input type="text" value={matchName}
                  onChange={e => setMatchName(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleSearch()}
                  placeholder="e.g. Bangladesh v Australia..."
                  className="form-control form-control-sm"
                  style={compactInputStyle} />
              </div>
              <div className="col-6 col-md-3">
                <label style={{ color: '#000', fontSize: '11px', marginBottom: '2px', display: 'block' }}>Type</label>
                <select value={betFaireType}
                  onChange={e => setBetFaireType(e.target.value)}
                  className="form-control form-control-sm"
                  style={compactInputStyle}>
                  <option value="">All Types</option>
                  <option value="betfair">Betfair</option>
                  <option value="fancy">Fancy</option>
                </select>
              </div>
              <div className="col-6 col-md-2">
                <button onClick={handleSearch} className="btn btn-sm w-100"
                  style={{ background: '#f59e0b', color: '#000', fontWeight: '700', fontSize: '12px', height: '30px' }}>
                  🔍 Search
                </button>
              </div>
              <div className="col-6 col-md-2">
                <button onClick={handleClear} className="btn btn-sm w-100"
                  style={{ background: '#fff', color: '#000', border: '1px solid #334155', fontSize: '12px', height: '30px' }}>
                  ✕ Clear
                </button>
              </div>
            </div>

            {/* ── Active Filter Indicator ── */}
            {(matchName || betFaireType) && (
              <div className="mb-2" style={{ fontSize: '11px', color: '#000' }}>
                🔍 Filtering by:
                {matchName    && <span className="ms-2 badge" style={{ background: '#78350f', color: '#fff' }}>Match: {matchName}</span>}
                {betFaireType && <span className="ms-2 badge" style={{ background: '#1e3a5f', color: '#fff' }}>Type: {betFaireType}</span>}
              </div>
            )}

            {/* ── Compact Summary Strip ── */}
            <div
              className="mb-2 d-flex flex-wrap"
              style={{
                background: '#fff',
                border: '1px solid #e2e8f0',
                borderRadius: '10px',
                overflow: 'hidden',
              }}
            >
              {statCards.map((c, i) => (
                <div
                  key={c.label}
                  className="flex-fill text-center"
                  style={{
                    minWidth: '95px',
                    padding: '6px 8px',
                    borderRight: i < statCards.length - 1 ? '1px solid #f1f5f9' : 'none',
                  }}
                >
                  <div style={{ color: '#94a3b8', fontSize: '10px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.02em' }}>
                    {c.label}
                  </div>
                  <div style={{ color: c.color, fontSize: '14px', fontWeight: '700', lineHeight: '1.3' }}>
                    {c.value}
                  </div>
                </div>
              ))}
            </div>

            {/* ── Nav Tabs: Match-wise Breakdown / Settled Bet Details ── */}
            <ul className="nav nav-tabs mb-0" style={{ borderBottom: '1px solid #e2e8f0' }}>
              <li className="nav-item">
                <button
                  onClick={() => setActiveTab('match')}
                  className="nav-link"
                  style={{
                    border: 'none',
                    borderBottom: activeTab === 'match' ? '2px solid #f59e0b' : '2px solid transparent',
                    color: activeTab === 'match' ? '#000' : '#64748b',
                    fontWeight: activeTab === 'match' ? '700' : '600',
                    fontSize: '12px',
                    background: 'transparent',
                    padding: '7px 12px',
                  }}
                >
                   Match History
                  {sortedMatches.length > 0 && (
                    <span className="ms-2 badge" style={{ background: '#f1f5f9', color: '#475569' }}>
                      {sortedMatches.length}
                    </span>
                  )}
                </button>
              </li>
              <li className="nav-item">
                <button
                  onClick={() => setActiveTab('detail')}
                  className="nav-link"
                  style={{
                    border: 'none',
                    borderBottom: activeTab === 'detail' ? '2px solid #f59e0b' : '2px solid transparent',
                    color: activeTab === 'detail' ? '#000' : '#64748b',
                    fontWeight: activeTab === 'detail' ? '700' : '600',
                    fontSize: '12px',
                    background: 'transparent',
                    padding: '7px 12px',
                  }}
                >
                  📋 Settled Bet Details
                  {detailData.length > 0 && (
                    <span className="ms-2 badge" style={{ background: '#f1f5f9', color: '#475569' }}>
                      {detailData.length}
                    </span>
                  )}
                </button>
              </li>
            </ul>

            {/* ── Tab Content ── */}
            <div
              className="card mb-3"
              style={{ background: '#fff', border: '1px solid #e2e8f0', borderTop: 'none', borderRadius: '0 0 12px 12px' }}
            >
              <div className="card-body p-0">

                {/* ── Match-wise Breakdown ── */}
                {activeTab === 'match' && (
                  sortedMatches.length > 0 ? (
                    <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                      <table className="table table-hover mb-0" style={{ color: '#000', width: 'max-content', minWidth: '100%' }}>
                        <thead style={{ borderBottom: '2px solid #e2e8f0' }}>
                          <tr>
                            {[
                              { key: 'matchName',       label: 'Match' },
                              { key: 'betFaireType',    label: 'Type' },
                              { key: 'totalBets',       label: 'Settled Bets' },
                              { key: 'playerCount',     label: 'Players' },
                              { key: 'totalWinAmount',  label: 'Players Won' },
                              { key: 'totalLossAmount', label: 'Players Lost' },
                              { key: 'netProfitLoss',   label: 'Net P/L' },
                              { key: 'lastSettledAt',   label: 'Last Settled' },
                            ].map(col => (
                              <th key={col.key}
                                onClick={() => handleMatchSort(col.key)}
                                style={thStyle}>
                                {col.label} <MatchSortIcon field={col.key} />
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {sortedMatches.map((m, i) => (
                            <tr key={i} style={{ borderBottom: '1px solid #f1f5f9' }}>
                              <td style={{ fontWeight: '600', color: '#000', fontSize: '12px', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', padding: '5px 8px' }}>
                                {m.matchName || '—'}
                              </td>
                              <td style={{ padding: '5px 8px', whiteSpace: 'nowrap' }}>
                                <span style={{
                                  padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '600',
                                  background: m.betFaireType === 'fancy' ? '#fef3c7' : '#dbeafe',
                                  color:      m.betFaireType === 'fancy' ? '#92400e'  : '#1e40af',
                                }}>
                                  {m.betFaireType || '—'}
                                </span>
                              </td>
                              <td style={{ color: '#000', fontSize: '12px', whiteSpace: 'nowrap', padding: '5px 8px' }}>{m.totalBets}</td>
                              <td style={{ color: '#000', fontSize: '12px', whiteSpace: 'nowrap', padding: '5px 8px' }}>{m.playerCount}</td>
                              <td style={{ color: '#16a34a', fontWeight: '600', fontSize: '12px', whiteSpace: 'nowrap', padding: '5px 8px' }}>
                                +৳{m.totalWinAmount?.toLocaleString()}
                              </td>
                              <td style={{ color: '#dc2626', fontWeight: '600', fontSize: '12px', whiteSpace: 'nowrap', padding: '5px 8px' }}>
                                ৳{m.totalLossAmount?.toLocaleString()}
                              </td>
                              <td style={{
                                fontWeight: '700', fontSize: '12px', whiteSpace: 'nowrap', padding: '5px 8px',
                                color: m.netProfitLoss >= 0 ? '#16a34a' : '#dc2626'
                              }}>
                                {m.netProfitLoss >= 0 ? '+' : ''}৳{m.netProfitLoss?.toLocaleString()}
                              </td>
                              <td style={{ color: '#555', fontSize: '11px', whiteSpace: 'nowrap', padding: '5px 8px' }}>
                                {formatDate(m.lastSettledAt)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-center py-4" style={{ color: '#555' }}>No match data found</div>
                  )
                )}

                {/* ── Settled Bet Details ── */}
                {activeTab === 'detail' && (
                  loading ? (
                    <div className="text-center p-4" style={{ color: '#555' }}>Loading...</div>
                  ) : (
                    <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                      <table className="table table-hover mb-0" style={{ color: '#000', width: 'max-content', minWidth: '100%' }}>
                        <thead style={{ borderBottom: '2px solid #e2e8f0' }}>
                          <tr>
                            <th style={thStyle} onClick={() => sortDetail('createdAt')}>
                              Date <SortIcon field="createdAt" />
                            </th>
                            <th style={thStyle}>Match</th>
                            <th style={thStyle}>Runner</th>
                            <th style={thStyle}>Type</th>
                            <th style={thStyle}>Action</th>
                            <th style={thStyle} onClick={() => sortDetail('amount')}>
                              Amount <SortIcon field="amount" />
                            </th>
                            <th style={thStyle} onClick={() => sortDetail('profitLoss')}>
                              P/L <SortIcon field="profitLoss" />
                            </th>
                            <th style={thStyle}>Player</th>
                            <th style={thStyle}>Bet ID</th>
                          </tr>
                        </thead>
                        <tbody>
                          {detailData.length > 0 ? (
                            detailData.map((item, idx) => (
                              <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                <td style={{ fontSize: '12px', color: '#000', whiteSpace: 'nowrap', padding: '5px 8px' }}>
                                  {formatDate(item.createdAt)}
                                </td>
                                <td style={{ fontSize: '12px', color: '#000', maxWidth: '160px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', padding: '5px 8px' }}>
                                  {item.matchName || '—'}
                                </td>
                                <td style={{ fontSize: '11px', color: '#555', maxWidth: '160px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', padding: '5px 8px' }}>
                                  {item.runnerName || '—'}
                                </td>
                                <td style={{ padding: '5px 8px', whiteSpace: 'nowrap' }}>
                                  <span style={{
                                    padding: '2px 7px', borderRadius: '10px', fontSize: '11px', fontWeight: '600',
                                    background: item.betFaireType === 'fancy' ? '#fef3c7' : '#dbeafe',
                                    color:      item.betFaireType === 'fancy' ? '#92400e'  : '#1e40af',
                                  }}>
                                    {item.betFaireType || '—'}
                                  </span>
                                </td>
                                <td style={{ padding: '5px 8px', whiteSpace: 'nowrap' }}>
                                  <span style={{
                                    padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '600',
                                    background: item.action === 'CREDIT' ? '#dcfce7' : '#fee2e2',
                                    color:      item.action === 'CREDIT' ? '#166534' : '#991b1b',
                                  }}>
                                    {item.action}
                                  </span>
                                </td>
                                <td style={{ color: '#000', fontWeight: '600', fontSize: '12px', whiteSpace: 'nowrap', padding: '5px 8px' }}>
                                  ৳{item.amount?.toLocaleString()}
                                </td>
                                <td style={{
                                  fontWeight: '700', fontSize: '12px', whiteSpace: 'nowrap', padding: '5px 8px',
                                  color: item.profitLoss > 0 ? '#16a34a' : item.profitLoss < 0 ? '#dc2626' : '#555'
                                }}>
                                  {item.profitLoss > 0 ? '+' : ''}৳{item.profitLoss?.toLocaleString()}
                                </td>
                                <td style={{ fontSize: '11px', color: '#555', whiteSpace: 'nowrap', padding: '5px 8px' }}>
                                  {item.username?.substring(0, 10)}...
                                </td>
                                <td style={{ fontSize: '11px', color: '#555', whiteSpace: 'nowrap', padding: '5px 8px' }}>
                                  {item.betId || '—'}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="9" className="text-center py-4" style={{ color: '#555' }}>
                                No settled bets found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )
                )}

              </div>
            </div>

            {/* ── Pagination (only relevant to Settled Bet Details tab) ── */}
            {activeTab === 'detail' && (
              <MyPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                marginPagesDisplayed={2}
                forcePage={currentPage.current - 1}
              />
            )}

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ExchangeSummery;